import { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Loader from "../main/Loader";
import { useValidateOtpMutation } from "../../store/services/AuthService";
import { decodeJwtAndSetCredentials } from "../../utils/decodeJwtAndSetCredentials";
import OTPInput, { OTPInputRef } from "../inputs/OTPInput";

interface TwoFactorFormProps {
  userData: any;
  onSuccess: () => void;
}

export default function TwoFactorForm({ userData, onSuccess }: TwoFactorFormProps) {
  const dispatch = useDispatch();
  const [otpCode, setOtpCode] = useState("");
  const [verifyOtp, { isLoading }] = useValidateOtpMutation();
  const otpInputRef = useRef<OTPInputRef>(null);

  // Focus automatico quando il componente si monta
  useEffect(() => {
    otpInputRef.current?.focus();
  }, []);

  const handleClear = () => {
    setOtpCode("");
    setTimeout(() => {
      otpInputRef.current?.focus();
    }, 0);
  }; 

  const handleSubmit = async () => {
    if (otpCode.length !== 6) {
      toast.warning("Inserisci un codice valido");
      return;
    }

    try {
      const res = await verifyOtp({
        code: otpCode,
        token: userData.twoFactorToken,
      }).unwrap();

      decodeJwtAndSetCredentials(
        dispatch,
        onSuccess,
        {
          accessToken: res.accessToken,
          refreshToken: res.refreshToken,
        },
        "Login completato!",
        (msg) => toast.error(msg)
      );
    } catch {
      toast.error("Codice OTP errato");
      setTimeout(() => {
        otpInputRef.current?.focus();
      }, 0);
    }
  };

  return (
    <div className="space-y-6 mt-10 text-center">
      {isLoading && <Loader />}

      <p>Inserisci il codice di 6 cifre mostrato dall'app Authenticator</p>

      <OTPInput ref={otpInputRef} value={otpCode} onChange={setOtpCode} />

      <div className="flex flex-col gap-y-4">
        <button
          onClick={handleSubmit}
          className="w-full bg-emerald-700 text-white font-semibold py-3 rounded-lg transition-colors"
        >
          Verifica
        </button>

        <button
          onClick={handleClear}
          className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-3 rounded-lg transition-colors"
        >
          Cancella
        </button>
      </div>
    </div>
  );
}